<script>
import HistoryNum from '@/views/LotteryResult/contents/Template'
// import UnderDev from '@/views/UnderDev'
export default {
  ...HistoryNum
}
</script>
